/**
 * @name Environment
 * @description Configuración de entornos para conexión de Talentry (Test, Onstage, Beta y Production)
 * @author César Rivera
 */

const LOCAL = 'https://localhost';
const MAIN_DOMAIN = 'https://app1.compusolucionesenlinea.com';
const PRODUCTION_DOMAIN = 'https://app2.compusolucionesenlinea.com';

const AUTH_PATH = 'Administracion/token';
const ADMIN_PATH = 'Administracion/api';
const INDICATORS_PATH = 'Mediciones/api';
const ACKNOWLEDGEMENTS_PATH = 'Reconocimientos/api';
const MY_DATA_PATH = 'MisDatos/api';
const ACCUMULATED_INDICATORS_PATH = 'IndicadoresAcumulados/api';
const EVALUATIONS_PATH = 'Evaluaciones/api';
const DEV_PLAN_PATH = 'PlanDesarrollo/api';
const ACADEMY_PATH = 'Academy/api';
const AUDIT_PATH = 'Auditoria/api';
const COMMUNICATION_PATH = 'Comunicacion/api';
const SALARY_PROMOTIONS_PATH = 'Sueldos/api';
const NOTIFICATIONS_PATH = 'Notificaciones/api';
const RECRUITMENT_PATH = 'Reclutamiento/api';
const ORGCHART_PATH = 'Organigrama/api';
const CHECKIN_PATH = 'CheckIn/api';
const HELPDESK_PATH = 'HelpDesk/api';

let environments = [
  // DEBUG
  {
    name: 'debug',
    domain: 'http://localhost:3000/#/',
    clientId: 'spaDebug',
    environmentId: 1,
    endpoints: {
      auth: `${LOCAL}:44300/token`,
      admin: `${LOCAL}:44300/api`,
      indicators: `${LOCAL}:44302/api`,
      acknowledgments: `${LOCAL}:44300/api`,
      myData: `${LOCAL}:59563/api`,
      accumulatedIndicators: `${LOCAL}:57345/api`,
      evaluations: `${LOCAL}:44303/api`,
      devPlan: 'https:TODO',
      salaryPromotions: `${LOCAL}:44314/api`,
    },
  },
  // TEST DEBUG
  {
    name: 'testDebug',
    domain: 'http://localhost:3000/#/',
    clientId: 'spaTest',
    environmentId: 1,
    endpoints: {
      auth: `${MAIN_DOMAIN}/test/${AUTH_PATH}`,
      admin: `${MAIN_DOMAIN}/test/${ADMIN_PATH}`,
      indicators: `${MAIN_DOMAIN}/test/${INDICATORS_PATH}`,
      acknowledgments: `${MAIN_DOMAIN}/test/${ACKNOWLEDGEMENTS_PATH}`,
      myData: `${MAIN_DOMAIN}/test/${MY_DATA_PATH}`,
      accumulatedIndicators: `${MAIN_DOMAIN}/test/${ACCUMULATED_INDICATORS_PATH}`,
      evaluations: `${MAIN_DOMAIN}/test/${EVALUATIONS_PATH}`,
      devPlan: `${MAIN_DOMAIN}/test/${DEV_PLAN_PATH}`,
      academy: `${MAIN_DOMAIN}/test/${ACADEMY_PATH}`,
      audit: `${MAIN_DOMAIN}/test/${AUDIT_PATH}`,
      communication: `${MAIN_DOMAIN}/test/${COMMUNICATION_PATH}`,
      salaryPromotions: `${MAIN_DOMAIN}/test/${SALARY_PROMOTIONS_PATH}`,
      notifications: `${MAIN_DOMAIN}/test/${NOTIFICATIONS_PATH}`,
      recruitment: `${MAIN_DOMAIN}/test/${RECRUITMENT_PATH}`,
      orgChart: `${MAIN_DOMAIN}/test/${ORGCHART_PATH}`,
      checkIn: `${MAIN_DOMAIN}/test/${CHECKIN_PATH}`,
      helpdesk: `${MAIN_DOMAIN}/test/${HELPDESK_PATH}`,
    },
  },
  // TEST
  {
    name: 'test',
    domain: 'https://talentrytest.tesselar.mx/#/',
    clientId: 'spaTest',
    environmentId: 1,
    config: {
      mode: 'test',
      analyticsTrackId: 'UA-81127481-1'
    },
    endpoints: {
      auth: `${MAIN_DOMAIN}/test/${AUTH_PATH}`,
      admin: `${MAIN_DOMAIN}/test/${ADMIN_PATH}`,
      indicators: `${MAIN_DOMAIN}/test/${INDICATORS_PATH}`,
      acknowledgments: `${MAIN_DOMAIN}/test/${ACKNOWLEDGEMENTS_PATH}`,
      myData: `${MAIN_DOMAIN}/test/${MY_DATA_PATH}`,
      accumulatedIndicators: `${MAIN_DOMAIN}/test/${ACCUMULATED_INDICATORS_PATH}`,
      evaluations: `${MAIN_DOMAIN}/test/${EVALUATIONS_PATH}`,
      devPlan: `${MAIN_DOMAIN}/test/${DEV_PLAN_PATH}`,
      academy: `${MAIN_DOMAIN}/test/${ACADEMY_PATH}`,
      audit: `${MAIN_DOMAIN}/test/${AUDIT_PATH}`,
      communication: `${MAIN_DOMAIN}/test/${COMMUNICATION_PATH}`,
      salaryPromotions: `${MAIN_DOMAIN}/test/${SALARY_PROMOTIONS_PATH}`,
      notifications: `${MAIN_DOMAIN}/test/${NOTIFICATIONS_PATH}`,
      recruitment: `${MAIN_DOMAIN}/test/${RECRUITMENT_PATH}`,
      orgChart: `${MAIN_DOMAIN}/test/${ORGCHART_PATH}`,
      checkIn: `${MAIN_DOMAIN}/test/${CHECKIN_PATH}`,
      helpdesk: `${MAIN_DOMAIN}/test/${HELPDESK_PATH}`,
    },
  },
  // ONSTAGE
  {
    name: 'onstage',
    domain: 'https://onstage.talentry.io/#/',
    clientId: 'spaOnstage',
    environmentId: 2,
    config: {
      mode: 'onstage',
      analyticsTrackId: 'UA-81127481-2'
    },
    endpoints: {
      auth: `${MAIN_DOMAIN}/onstage/${AUTH_PATH}`,
      admin: `${MAIN_DOMAIN}/onstage/${ADMIN_PATH}`,
      indicators: `${MAIN_DOMAIN}/onstage/${INDICATORS_PATH}`,
      acknowledgments: `${MAIN_DOMAIN}/onstage/${ACKNOWLEDGEMENTS_PATH}`,
      myData: `${MAIN_DOMAIN}/onstage/${MY_DATA_PATH}`,
      accumulatedIndicators: `${MAIN_DOMAIN}/onstage/${ACCUMULATED_INDICATORS_PATH}`,
      evaluations: `${MAIN_DOMAIN}/onstage/${EVALUATIONS_PATH}`,
      devPlan: `${MAIN_DOMAIN}/onstage/${DEV_PLAN_PATH}`,
      academy: `${MAIN_DOMAIN}/onstage/${ACADEMY_PATH}`,
      audit: `${MAIN_DOMAIN}/onstage/${AUDIT_PATH}`,
      communication: `${MAIN_DOMAIN}/onstage/${COMMUNICATION_PATH}`,
      salaryPromotions: `${MAIN_DOMAIN}/onstage/${SALARY_PROMOTIONS_PATH}`,
      notifications: `${MAIN_DOMAIN}/onstage/${NOTIFICATIONS_PATH}`,
      recruitment: `${MAIN_DOMAIN}/onstage/${RECRUITMENT_PATH}`,
      orgChart: `${MAIN_DOMAIN}/onstage/${ORGCHART_PATH}`,
      checkIn: `${MAIN_DOMAIN}/onstage/${CHECKIN_PATH}`,
      helpdesk: `${MAIN_DOMAIN}/onstage/${HELPDESK_PATH}`,
    },
  },
  // BETA
  {
    name: 'beta',
    domain: 'https://tesselar.talentry.io/#/',
    clientId: 'spaBeta',
    environmentId: 0,
    config: {
      mode: 'beta',
      analyticsTrackId: 'UA-81127481-3'
    },
    endpoints: {
      auth: `${MAIN_DOMAIN}/beta/${AUTH_PATH}`,
      admin: `${MAIN_DOMAIN}/beta/${ADMIN_PATH}`,
      indicators: `${MAIN_DOMAIN}/beta/${INDICATORS_PATH}`,
      acknowledgments: `${MAIN_DOMAIN}/beta/${ACKNOWLEDGEMENTS_PATH}`,
      myData: `${MAIN_DOMAIN}/beta/${MY_DATA_PATH}`,
      accumulatedIndicators: `${MAIN_DOMAIN}/beta/${ACCUMULATED_INDICATORS_PATH}`,
      evaluations: `${MAIN_DOMAIN}/beta/${EVALUATIONS_PATH}`,
      devPlan: `${MAIN_DOMAIN}/beta/${DEV_PLAN_PATH}`,
      academy: `${MAIN_DOMAIN}/beta/${ACADEMY_PATH}`,
      audit: `${MAIN_DOMAIN}/beta/${AUDIT_PATH}`,
      communication: `${MAIN_DOMAIN}/beta/${COMMUNICATION_PATH}`,
      salaryPromotions: `${MAIN_DOMAIN}/beta/${SALARY_PROMOTIONS_PATH}`,
      recruitment: `${MAIN_DOMAIN}/beta/${RECRUITMENT_PATH}`,
      orgChart: `${MAIN_DOMAIN}/beta/${ORGCHART_PATH}`,
      checkIn: `${MAIN_DOMAIN}/beta/${CHECKIN_PATH}`,
      helpdesk: `${MAIN_DOMAIN}/beta/${HELPDESK_PATH}`,
    },
  },
  // PRODUCTION
  {
    name: 'production',
    domain: 'https://app.talentry.io/#/',
    clientId: 'spaProduction',
    environmentId: 3,
    config: {
      mode: 'production',
      analyticsTrackId: 'UA-81127481-4'
    },
    endpoints: {
      auth: `${PRODUCTION_DOMAIN}/${AUTH_PATH}`,
      admin: `${PRODUCTION_DOMAIN}/${ADMIN_PATH}`,
      indicators: `${PRODUCTION_DOMAIN}/${INDICATORS_PATH}`,
      acknowledgments: `${PRODUCTION_DOMAIN}/${ACKNOWLEDGEMENTS_PATH}`,
      myData: `${PRODUCTION_DOMAIN}/${MY_DATA_PATH}`,
      accumulatedIndicators: `${PRODUCTION_DOMAIN}/${ACCUMULATED_INDICATORS_PATH}`,
      evaluations: `${PRODUCTION_DOMAIN}/${EVALUATIONS_PATH}`,
      devPlan: `${PRODUCTION_DOMAIN}/${DEV_PLAN_PATH}`,
      academy: `${PRODUCTION_DOMAIN}/${ACADEMY_PATH}`,
      audit: `${PRODUCTION_DOMAIN}/${AUDIT_PATH}`,
      communication: `${PRODUCTION_DOMAIN}/${COMMUNICATION_PATH}`,
      salaryPromotions: `${PRODUCTION_DOMAIN}/${SALARY_PROMOTIONS_PATH}`,
      notifications: `${PRODUCTION_DOMAIN}/${NOTIFICATIONS_PATH}`,
      recruitment: `${PRODUCTION_DOMAIN}/${RECRUITMENT_PATH}`,
      orgChart: `${PRODUCTION_DOMAIN}/${ORGCHART_PATH}`,
      checkIn: `${PRODUCTION_DOMAIN}/${CHECKIN_PATH}`,
      helpdesk: `${PRODUCTION_DOMAIN}/${HELPDESK_PATH}`,
    },
  }
];

let current = null;

/**
 * Configura el entorno actual
 */
const environmentConfig = () => {
  const URL = window.location.href;
  const subDomain = URL.split('//')[1];

  let environmentName = subDomain.indexOf('localhost') === 0 ? 'testDebug' : subDomain.split('.')[0];

  switch (environmentName) {
    case 'talentrytest':
      environmentName = 'test';
      break;
    case 'tesselar':
      environmentName = 'beta';
      break;
    case 'app':
      environmentName = 'production';
      break;
    default:
      break;
  }
  setCurrent(environmentName);
};

/**
 * Consulta el entorno actual
 * @return {any}
 */
const getCurrent = () => {
  return current;
};

/**
 * Actualiza el entorno actual según se pase el argumento si es correcto
 * @param {string} environmentName 'test', 'onstage', 'beta', 'production'
 */
const setCurrent = (environmentName) => {
  current = environments.filter((environment) => environment.name === environmentName)[0] || environments.filter((environment) => environment.name === 'debug')[0];
};

environmentConfig();

export const Environment = {
  environmentConfig,
  getCurrent,
  setCurrent
};